/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Favorite } from './Favorite';
import type { Warmup } from './Warmup';
import type { Exercise } from './Exercise';
import type { VoucherCode } from './VoucherCode';
import type { Assessment } from './Assessment';
import type { VoiceType } from './VoiceType';
import type { Subscription } from './Subscription';
import type { UserGoal } from './UserGoal';
import type { Session } from './Session';
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    identityId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    state?: number;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    modified?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    stripeId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    revenueCatId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    mixpanelId?: string;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    archived?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    voiceTypeId?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    onboardingCompleted?: boolean;
    /**
     * 
     * @type {Array<Assessment>}
     * @memberof User
     */
    assessments?: Array<Assessment> | null;
    /**
     * 
     * @type {Array<Exercise>}
     * @memberof User
     */
    exercises?: Array<Exercise> | null;
    /**
     * 
     * @type {Array<Favorite>}
     * @memberof User
     */
    favorites?: Array<Favorite> | null;
    /**
     * 
     * @type {Array<Session>}
     * @memberof User
     */
    sessions?: Array<Session> | null;
    /**
     * 
     * @type {Array<Subscription>}
     * @memberof User
     */
    subscriptions?: Array<Subscription> | null;
    /**
     * 
     * @type {Array<UserGoal>}
     * @memberof User
     */
    userGoals?: Array<UserGoal> | null;
    /**
     * 
     * @type {VoiceType}
     * @memberof User
     */
    voiceType?: VoiceType;
    /**
     * 
     * @type {Array<VoucherCode>}
     * @memberof User
     */
    voucherCodes?: Array<VoucherCode> | null;
    /**
     * 
     * @type {Array<Warmup>}
     * @memberof User
     */
    warmups?: Array<Warmup> | null;
}

/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'identityId': json['identityId'] == null ? undefined : json['identityId'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'state': json['state'] == null ? undefined : json['state'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'modified': json['modified'] == null ? undefined : (new Date(json['modified'])),
        'stripeId': json['stripeId'] == null ? undefined : json['stripeId'],
        'revenueCatId': json['revenueCatId'] == null ? undefined : json['revenueCatId'],
        'mixpanelId': json['mixpanelId'] == null ? undefined : json['mixpanelId'],
        'archived': json['archived'] == null ? undefined : (new Date(json['archived'])),
        'voiceTypeId': json['voiceTypeId'] == null ? undefined : json['voiceTypeId'],
        'onboardingCompleted': json['onboardingCompleted'] == null ? undefined : json['onboardingCompleted'],
        'assessments': json['assessments'] == null ? undefined : ((json['assessments'] as Array<any>).map((require('./Assessment') as typeof import('./Assessment')).AssessmentFromJSON)),
        'exercises': json['exercises'] == null ? undefined : ((json['exercises'] as Array<any>).map((require('./Exercise') as typeof import('./Exercise')).ExerciseFromJSON)),
        'favorites': json['favorites'] == null ? undefined : ((json['favorites'] as Array<any>).map((require('./Favorite') as typeof import('./Favorite')).FavoriteFromJSON)),
        'sessions': json['sessions'] == null ? undefined : ((json['sessions'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionFromJSON)),
        'subscriptions': json['subscriptions'] == null ? undefined : ((json['subscriptions'] as Array<any>).map((require('./Subscription') as typeof import('./Subscription')).SubscriptionFromJSON)),
        'userGoals': json['userGoals'] == null ? undefined : ((json['userGoals'] as Array<any>).map((require('./UserGoal') as typeof import('./UserGoal')).UserGoalFromJSON)),
        'voiceType': json['voiceType'] == null ? undefined : (require('./VoiceType') as typeof import('./VoiceType')).VoiceTypeFromJSON(json['voiceType']),
        'voucherCodes': json['voucherCodes'] == null ? undefined : ((json['voucherCodes'] as Array<any>).map((require('./VoucherCode') as typeof import('./VoucherCode')).VoucherCodeFromJSON)),
        'warmups': json['warmups'] == null ? undefined : ((json['warmups'] as Array<any>).map((require('./Warmup') as typeof import('./Warmup')).WarmupFromJSON)),
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'identityId': value['identityId'],
        'email': value['email'],
        'firstName': value['firstName'],
        'state': value['state'],
        'created': value['created'] == null ? value['created'] : value['created'].toISOString(),
        'modified': value['modified'] == null ? value['modified'] : value['modified'].toISOString(),
        'stripeId': value['stripeId'],
        'revenueCatId': value['revenueCatId'],
        'mixpanelId': value['mixpanelId'],
        'archived': value['archived'] == null ? value['archived'] : value['archived'].toISOString(),
        'voiceTypeId': value['voiceTypeId'],
        'onboardingCompleted': value['onboardingCompleted'],
        'assessments': value['assessments'] == null ? undefined : ((value['assessments'] as Array<any>).map((require('./Assessment') as typeof import('./Assessment')).AssessmentToJSON)),
        'exercises': value['exercises'] == null ? undefined : ((value['exercises'] as Array<any>).map((require('./Exercise') as typeof import('./Exercise')).ExerciseToJSON)),
        'favorites': value['favorites'] == null ? undefined : ((value['favorites'] as Array<any>).map((require('./Favorite') as typeof import('./Favorite')).FavoriteToJSON)),
        'sessions': value['sessions'] == null ? undefined : ((value['sessions'] as Array<any>).map((require('./Session') as typeof import('./Session')).SessionToJSON)),
        'subscriptions': value['subscriptions'] == null ? undefined : ((value['subscriptions'] as Array<any>).map((require('./Subscription') as typeof import('./Subscription')).SubscriptionToJSON)),
        'userGoals': value['userGoals'] == null ? undefined : ((value['userGoals'] as Array<any>).map((require('./UserGoal') as typeof import('./UserGoal')).UserGoalToJSON)),
        'voiceType': (require('./VoiceType') as typeof import('./VoiceType')).VoiceTypeToJSON(value['voiceType']),
        'voucherCodes': value['voucherCodes'] == null ? undefined : ((value['voucherCodes'] as Array<any>).map((require('./VoucherCode') as typeof import('./VoucherCode')).VoucherCodeToJSON)),
        'warmups': value['warmups'] == null ? undefined : ((value['warmups'] as Array<any>).map((require('./Warmup') as typeof import('./Warmup')).WarmupToJSON)),
    };
}

